import { getCurrentMobileRouteContext } from '@/config/tenant-route';
import { applyLanguageEnvironment, defaultLanguage } from '@/i18n/util.ts';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { defaultNS, resources } from './locales';

const routeContext = getCurrentMobileRouteContext();
const routeLocale = routeContext.locale;
applyLanguageEnvironment(routeLocale, routeContext.routePath);

void i18n.use(initReactI18next).init({
  postProcess: ['tms-marker'],
  resources,
  defaultNS,
  fallbackLng: defaultLanguage,
  lng: routeLocale,
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});
